"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSetScreenSize;
exports.useScreenSize = useScreenSize;
var _react = require("@chakra-ui/react");
var _react2 = require("react");
var _AppDataContext = require("../store/AppDataContext");
function useSetScreenSize() {
  var _theme$breakpoints, _theme$breakpoints2, _theme$breakpoints3, _theme$breakpoints4, _theme$breakpoints5, _theme$breakpoints6, _theme$breakpoints7, _theme$breakpoints8, _theme$breakpoints9, _theme$breakpoints10, _theme$breakpoints11, _theme$breakpoints12;
  var dispatch = (0, _AppDataContext.useAppDataDispatch)();
  var theme = (0, _react.useTheme)();
  var [base, mobile, xs, sm, md, lg, xl] = (0, _react.useMediaQuery)(["(max-width: calc(".concat(theme === null || theme === void 0 || (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.mobile, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.mobile, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3.xs, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints4 = theme.breakpoints) === null || _theme$breakpoints4 === void 0 ? void 0 : _theme$breakpoints4.xs, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints5 = theme.breakpoints) === null || _theme$breakpoints5 === void 0 ? void 0 : _theme$breakpoints5.sm, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints6 = theme.breakpoints) === null || _theme$breakpoints6 === void 0 ? void 0 : _theme$breakpoints6.sm, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints7 = theme.breakpoints) === null || _theme$breakpoints7 === void 0 ? void 0 : _theme$breakpoints7.md, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints8 = theme.breakpoints) === null || _theme$breakpoints8 === void 0 ? void 0 : _theme$breakpoints8.md, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints9 = theme.breakpoints) === null || _theme$breakpoints9 === void 0 ? void 0 : _theme$breakpoints9.lg, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints10 = theme.breakpoints) === null || _theme$breakpoints10 === void 0 ? void 0 : _theme$breakpoints10.lg, ") and (max-width: calc(").concat(theme === null || theme === void 0 || (_theme$breakpoints11 = theme.breakpoints) === null || _theme$breakpoints11 === void 0 ? void 0 : _theme$breakpoints11.xl, " - 1px))"), "(min-width: ".concat(theme === null || theme === void 0 || (_theme$breakpoints12 = theme.breakpoints) === null || _theme$breakpoints12 === void 0 ? void 0 : _theme$breakpoints12.xl, ")")]);
  (0, _react2.useEffect)(() => {
    switch (true) {
      case base:
        dispatch({
          type: 'ui/screenSize',
          payload: 'base'
        });
        break;
      case mobile:
        dispatch({
          type: 'ui/screenSize',
          payload: 'mobile'
        });
        break;
      case xs:
        dispatch({
          type: 'ui/screenSize',
          payload: 'xs'
        });
        break;
      case sm:
        dispatch({
          type: 'ui/screenSize',
          payload: 'sm'
        });
        break;
      case md:
        dispatch({
          type: 'ui/screenSize',
          payload: 'md'
        });
        break;
      case lg:
        dispatch({
          type: 'ui/screenSize',
          payload: 'lg'
        });
        break;
      case xl:
        dispatch({
          type: 'ui/screenSize',
          payload: 'xl'
        });
        break;
    }
  }, [base, mobile, xs, sm, md, lg, xl, dispatch]);
}
function useScreenSize() {
  var sizes = {
    isLessThanMobile: undefined,
    isLessThanXs: undefined,
    isLessThanSm: undefined,
    isLessThanMd: undefined,
    isLessThanLg: undefined,
    isLessThanXl: undefined
  };
  var appData = (0, _AppDataContext.useAppData)();
  switch (appData === null || appData === void 0 ? void 0 : appData.screenSize) {
    case 'base':
      return {
        isLessThanMobile: true,
        isLessThanXs: true,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'mobile':
      return {
        isLessThanMobile: false,
        isLessThanXs: true,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'xs':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: true,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'sm':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: true,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'md':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: true,
        isLessThanXl: true
      };
    case 'lg':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: false,
        isLessThanXl: true
      };
    case 'xl':
      return {
        isLessThanMobile: false,
        isLessThanXs: false,
        isLessThanSm: false,
        isLessThanMd: false,
        isLessThanLg: false,
        isLessThanXl: false
      };
    default:
      return sizes;
  }
}